<div class="brands-carousel">
    <div class="brands-track">
        <div class="brand-item" *ngFor="let brand of duplicatedBrands">
            <img [src]="brand.src" [alt]="brand.alt" width="100" height="80" loading="lazy" decoding="async">
        </div>
    </div>
</div>
